import listActions from 'src/modules/location/list/locationListActions';
import LocationService from 'src/modules/location/locationService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'LOCATION_DESTROY';

const locationDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: locationDestroyActions.DESTROY_STARTED,
      });

      await LocationService.destroyAll([id]);

      dispatch({
        type: locationDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.location.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());
      dispatch(listActions.doFetchTemplates());

      getHistory().push('/location');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());
      dispatch(listActions.doFetchTemplates());

      dispatch({
        type: locationDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: locationDestroyActions.DESTROY_ALL_STARTED,
      });

      await LocationService.destroyAll(ids);

      dispatch({
        type: locationDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
        dispatch(listActions.doFetchTemplates());
      }

      Message.success(
        i18n('entities.location.destroyAll.success'),
      );

      getHistory().push('/location');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());
      dispatch(listActions.doFetchTemplates());

      dispatch({
        type: locationDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default locationDestroyActions;
